import { FETCH_USERS_SUCCESS, GENERATE_USERS_PASSWORD_SUCCESS } from '../constant/actionType';

const initialState = {
  password: '',
  users: []
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_SUCCESS:
      return {
        users: action.data
      };
    case GENERATE_USERS_PASSWORD_SUCCESS:
      return { ...state, password: action.data };
    default:
      return state;
  }
};

export default userReducer;
